import { Box, Text, Message } from 'ui'
import { useIntercom } from 'react-use-intercom'

interface Props {
  message?: string
  clearError?: () => void
}

export function ErrorMessage(props: Props) {
  const { clearError, message } = props
  const { show: showIntercom } = useIntercom()

  return (
    <Box p={4}>
      <Message variant={'error'}>
        { message || 'Something went wrong.'} Please try again or&nbsp;
        <Text
          color={'primary'}
          onClick={showIntercom}
          fontWeight={2}
          style={{
            display: 'inline-block',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          contact support
        </Text>
        &nbsp;if you require further assistance.
      </Message>
      <Box mt={3}>
        <a onClick={clearError}>Click here</a> to try again.
      </Box>
    </Box>
  )
}
